module.exports = __webpack_public_path__ + "img/1559023599.09bbaf1c.jpg";